import React from 'react'
import Layout from '../components/system/layout'
import VenueProfiles from '../components/venue-info/venue-profiles'
import Meta from '../components/system/meta'
import gql from 'graphql-tag'
import { useQuery } from '@apollo/react-hooks'
import VenueInfoModel from '../models/venue-info'
import { withApollo } from '../apollo/apollo'

const VENUE_INFO = gql`
  query VenueInfo {
    allVenueInfo {
      venueId
      heading
      description
      images {
        title
        url
      }
    }
  }
`

const VenueInfo = () => {
  const { data, loading, error } = useQuery(VENUE_INFO)

  if (!data || !data.allVenueInfo) {
    return null
  }

  const profiles: VenueInfoModel[] = data.allVenueInfo

  return (
    <Layout>
      <Meta title="Venue Info" />
      <VenueProfiles profiles={profiles} />
    </Layout>
  )
}

export default withApollo(VenueInfo)
